import { wrap } from 'comlink';

// Определяем интерфейс worker-функций для типизации
interface StrataiMathWorker {
    initialize: () => Promise<void>;
    cosineSimilarityInternal: (vec1: number[], vec2: number[]) => Promise<number>;
}

// Инициализация worker с поддержкой TypeScript
const worker = new Worker(new URL('./workers/strataimath.worker.js', import.meta.url));
const { initialize, cosineSimilarityInternal } = wrap<StrataiMathWorker>(worker);

let initialized = false;

// Функция для вычисления косинусного сходства
export const cosineSimilarity = async (vec1: number[], vec2: number[]): Promise<number> => {
    if (!initialized) {
        await initialize();
        initialized = true;
    }

    try {
        const result = await cosineSimilarityInternal(vec1, vec2);
        return result;
    } catch (error) {
        throw new Error(`Error computing cosine similarity: ${(error as Error).message}`);
    }
};
